var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading6_container"},[_c('div',{staticClass:"lava-lamp"},[_c('div',{staticClass:"bubble"}),_c('div',{staticClass:"bubble1"}),_c('div',{staticClass:"bubble2"}),_c('div',{staticClass:"bubble3"})])])
}]

export { render, staticRenderFns }